module.exports = __webpack_public_path__ + "img/weibo-circle.f9973a13.svg";